<template>
  <div v-if="student" class="mailing-label" :style="computedStyle(settings.label.style)">
    <p class="mailing-label-name" :style="computedStyle(settings.name.style)">
      <template v-if="student.name">
        <template v-if="settings.name.textFormat === 'lastNameFirstName'">
          {{ student.name.last }}, {{ student.name.first }}
        </template>
        <template v-else>
          {{ student.name.first }} {{ student.name.last }}
        </template>
      </template>
      <template v-else>
        <span class="text-danger">No Name</span>
      </template>
    </p>

    <template v-if="student.address">
      <p class="mailing-label-address" :style="computedStyle(settings.address.style)">{{ student.address.line1 }}</p>
      <p class="mailing-label-address" :style="computedStyle(settings.address.style)">{{ student.address.line2 }}</p>
      <p class="mailing-label-address" :style="computedStyle(settings.address.style)">{{ student.address.city }}, {{ student.address.state }} {{ student.address.zip }}</p>
    </template>

  </div>
</template>

<script>
import styleMixin from '@/mixins/style.mixin';

export default {
  name: 'Label',
  mixins: [ styleMixin ],
  props: {
    settings: {
      type: Object,
      required: true
    },
    student: {
      type: Object,
      default: () => ({
        name: {
          first: '',
          last: '',
        },
        address: {
          line1: '',
          line2: '',
          city: '',
          state: '',
          zip: '',
        },
      }),
    },
  },
};
</script>

<style scoped>
  .mailing-label {
    width: 100%;
    height: 100%;
    padding: 0.125in;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    page-break-inside: avoid;
    font-size: 12px;
    border: dashed 1px #ccc;
  }

  .mailing-label-name,
  .mailing-label-address {
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .mailing-label-address {
    font-size: 9pt;
  }
</style>
